import React, {Component} from 'react';
import PropTypes from 'prop-types';

import cogoToast from 'cogo-toast';

class PopupMsg extends Component {
	componentDidUpdate(prevProps) {
		if (prevProps.timestamp !== this.props.timestamp) {
			if (this.props.isError) {
				cogoToast.error(<div dangerouslySetInnerHTML={{__html: this.props.msg}} />)
			} else {
				cogoToast.success(<div dangerouslySetInnerHTML={{__html: this.props.msg}} />)
			}
		}
	}

	render() {
		return (
			<div />
	  );
	}
}

PopupMsg.propTypes = {
	msg: PropTypes.string,
	isError: PropTypes.bool,
	timestamp: PropTypes.number,
};

export default PopupMsg;
